import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Field } from "@progress/kendo-react-form";
import { Checkbox } from "@progress/kendo-react-inputs";
import { FormInput, FormDropDownListById, FormCheckbox, FormDatePicker, FormDateTimePicker, FormMultiSelect} from "../../../forms/form-components";
import { ProFormDateTimePicker } from "../../../components/proformdatetimepicker";
import { ProFormDatePicker } from "../../../components/proformdatepicker";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const WidgetFilterFormParameters = props => {
    const { formRenderProps, pageState, formState, onFormValueChange, onParameterChange, isGlobal, ...other} = props;

    // const currentTheme = useSelector(state => state.currentTheme);
    // const dispatch = useDispatch();

    const parameters = formState.parameters;
    const { t } = useTranslation();
    const title = isGlobal ? t("reporting.view.global") : t("reporting.view.filter1");

    return (
        <Fragment>
            <div className="widget-filter-form-parameters">
                <div className="widget-filter-form-group" style={{marginTop: 2, marginBottom: 0}}>
                    <div className="header">
                        {title}
                    </div>
                    <div className="content" style={{padding: "12px 20xp"}}>
                    {
                            !isGlobal &&
                            <div className="row combine-parameters" style={{marginBottom: 24}}>
                                <Checkbox style={{marginRight: 4}} label={t("reporting.view.combine")} value={formState.combineParameters} onChange={e => onFormValueChange({id: "combineParameters", value: e.value})}/>                          
                            </div>
                    }
                    {                            
                        parameters.map((p, index) => {
                            //const p = formState.parameters.find(e => e.Id == parameter.Id);
                            const dataTypeId = p.DataTypeId;
                            const isLookup = p.IsLookup;
                            let lookupValues = p.LookupValues;
                            const allowMultiple = p.AllowMultiple;
                            const format = p.Format;

                            if (dataTypeId == 1)//checkbox
                                return (
                                    <div key={index} className="row">
                                        <div style={{flex:1}}>
                                            <Field
                                                id={p.Name}
                                                name={p.Name}
                                                label={p.Title}
                                                component={FormCheckbox}                                                
                                                style={{marginTop:2}}
                                                onChange={e => onParameterChange({formRenderProps:formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: e.target.value})}
                                            />
                                        </div>
                                    </div>
                                );
                            else  if (dataTypeId == 3)//textbox
                                return (
                                    <div key={index} className="row">
                                        <div style={{flex:1}}>
                                            <Field
                                                id={p.Name}
                                                name={p.Name}
                                                label={p.Title + (p.IsRequired ? "*" : "")}
                                                component={FormInput}                                                                                                
                                                style={{marginTop:2}}
                                                onChange={e => onParameterChange({formRenderProps:formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: e.target.value})}
                                            />
                                        </div>
                                    </div>
                                );
                            else  if (dataTypeId == 4)//date
                                return (
                                    <div key={index} className="row">
                                        <div style={{flex:1}}>
                                            <Field
                                                id={p.Name}
                                                name={p.Name}
                                                label={p.Title + (p.IsRequired ? "*" : "")}
                                                component={ProFormDatePicker} format={p.Format ? p.Format : undefined}                                                                                           
                                                style={{marginTop:2}}
                                                onDateKeySelected={(dateKey, dateValue) => {
                                                    onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: new Date(dateValue)});
                                                    formRenderProps.onChange(p.Name, {value: dateValue == null ? null : new Date(dateValue)});
                                                }}
                                                onChange={e => onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: e.target.value})}
                                            />
                                        </div>
                                    </div>
                                );
                                else  if (dataTypeId == 5)//datetime
                                    return (
                                        <div key={index} className="row">
                                            <div style={{flex:1}}>
                                                <Field
                                                    id={p.Name}
                                                    name={p.Name}
                                                    label={p.Title + (p.IsRequired ? "*" : "")}
                                                    component={ProFormDateTimePicker} format={p.Format ? p.Format : undefined}                                                                                           
                                                    style={{marginTop:2}}
                                                    onDateKeySelected={(dateKey, dateValue) => {
                                                        onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: new Date(dateValue)});
                                                        formRenderProps.onChange(p.Name, {value: dateValue == null ? null : new Date(dateValue)});
                                                    }}
                                                    onChange={e => onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    );
                            else  if (dataTypeId == 2)//numeric
                            {
                                if (!isLookup)
                                    return (
                                        <div key={index} className="row">
                                            <div style={{flex:1}}>
                                                <Field
                                                    type={"number"}
                                                    id={p.Name}
                                                    name={p.Name}
                                                    label={p.Title + (p.IsRequired ? "*" : "")}
                                                    component={FormInput}                                                                                                
                                                    style={{marginTop:2}}
                                                    onChange={e => onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: false, value: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    );
                                else
                                {
                                    if (allowMultiple)
                                    {
                                        return (
                                            <div key={index} className="row">
                                                <div style={{flex:1}}>
                                                    <Field
                                                        id={p.Name}
                                                        name={p.Name}
                                                        label={p.Title + (p.IsRequired ? "*" : "")}
                                                        component={FormMultiSelect} data={lookupValues} textField="Title" dataItemKey="Id"                                                                                           
                                                        style={{marginTop:2}}
                                                        onChange={e => onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: true, isLookup: true, value: e.value})}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    }
                                    else
                                    {
                                        lookupValues = [...p.LookupValues];
                                        lookupValues.splice(0, 0, {Id:0, Title: "N/A"});

                                        return (
                                            <div key={index} className="row">
                                                <div style={{flex:1}}>
                                                <Field
                                                    id={p.Name}
                                                    name={p.Name}
                                                    label={p.Title + (p.IsRequired ? "*" : "")}
                                                    component={FormDropDownListById} 
                                                    data={lookupValues} dataItemKey="Id" textField="Title"  
                                                    onChange={e => onParameterChange({formRenderProps: formRenderProps, id: p.Id, name: p.Name, dataTypeId: p.DataTypeId, isRequired: p.IsRequired, allowMultiple: false, isLookup: true, value: e.value})}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    }
                                }
                            }                                    
                        })
                    }
                    </div>
                </div>
            </div>
            <style>
                {
                    `
                    .widget-filter-form-parameters
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex:1;
                    }
                    `
                }
            </style>
        </Fragment>
    );
};